import { NavigationExtras } from '@angular/router';

import { Link } from '../link/link';
import { TrackingData } from '../tracking/trackingData';

export class ExtendedLink {
    public currentTab = false;
    public label?: string;
    public link!: Link;
    public navigationExtras?: NavigationExtras;
    public params?: Map<string, string>;
    public path?: string;
    public shouldKeepBackPage = true;
    public shouldKeepBackRoute = true;
    public shouldKeepQueryParams = true;
    public trackingData!: TrackingData;

    public constructor(init?: Partial<ExtendedLink>) {
        Object.assign(this, init);
    }
}
